export default __webpack_public_path__ + "static/media/AM.c644ef33.svg";